import React from 'react';

const ITEMS = ['Hand-piped', 'Vintage finish', 'Personalised messages', 'Fresh to order'];

export default function Strip() {
  return (
    <div style={{ background:'var(--plum-deep)', color:'#f7e8e2', padding:'18px 26px' }}>
      <div className="kt-strip-inner" style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', alignItems:'center', gap:'10px 0', fontFamily:'var(--serif)', fontSize:21, fontStyle:'italic' }}>
        {ITEMS.map((item, i) => (
          <span key={item} style={{ display:'inline-flex', alignItems:'center' }}>
            {item}
            {i < ITEMS.length - 1 && (
              <span className="kt-strip-dot" style={{ width:5, height:5, borderRadius:'50%', background:'var(--gold)', display:'inline-block', margin:'0 22px', flexShrink:0 }} />
            )}
          </span>
        ))}
      </div>
      <style>{`
        @media(max-width:640px){
          .kt-strip-inner{
            display:grid!important;
            grid-template-columns:1fr 1fr;
            gap:12px 0;
            text-align:center;
          }
          .kt-strip-inner > span { justify-content:center; }
          .kt-strip-dot{ display:none!important; }
        }
      `}</style>
    </div>
  );
}
